import React, { useContext, useRef, useEffect } from 'react'

//Contexto
import ConexContext from "../../context/conex/ConexContext";
//SVG
import { ReactComponent as SearchIcon } from "../../assets/img/iconos/acae_zoom.svg";


const Filtrado = ({ setListParams, Filtro }) => {
	const WaitSearch = require('../../config/config.json').WaitSearch;
	const { loc } = useContext(ConexContext)//contexto
	const filtro = useRef()
	const timeoutRef = useRef(null);

	useEffect(() => {
		filtro.current.value = Filtro
		filtro.current.focus();
	}, [Filtro])

	const handleChange = () => {
		// Limpiamos cualquier timeout anterior
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		// Esperamos 1.5 segundos desde la última tecla
		timeoutRef.current = setTimeout(() => {
			if (filtro.current){
				setListParams((prev) => ({ ...prev, filtro: filtro.current.value, ini: 0 }));
				filtro.current.focus();
			}
		}, WaitSearch);
	};

	return (
		<>
			<div className="search">
				<form onSubmit={(event) => {
					event.preventDefault(); setListParams((prev) => ({
						...prev,
						filtro: filtro.current.value,
						ini: 0
					}))
					filtro.current.focus();
				}}>
					<input ref={filtro} type="search" placeholder={loc("Buscar")} defaultValue={Filtro}
						onChange={handleChange}
						// onBlur={() => {
						// 	setListParams((prev) => ({ ...prev, filtro: filtro.current.value }));
						// }}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								setListParams((prev) => ({ ...prev, filtro: filtro.current.value, ini:0 }));
								filtro.current.focus();
							}
						}}
						></input>
					<SearchIcon alt={loc("Buscar")} title={loc("Buscar")} />
				</form>
			</div>
		</>
	)
}

export default Filtrado